import ContactAutoCreationSwitch from "components/modules/crm/email-settings/ContactAutoCreationSwitch";
import EventVisibilitySection from "components/modules/crm/email-settings/EventVisibilitySection";
import { Col, Nav, Row, Tab } from "react-bootstrap";

interface EmailData {
  id: string;
  email: string;
  content: string;
}

const emailsData: EmailData[] = [
  {
    id: "home",
    email: "mastercleaningseo@gmail.com",
    content:
      "Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth.",
  },
  {
    id: "profile",
    email: "stellartalentseo@gmail.com",
    content:
      "Food truck fixie locavore, accusamus mcsweeney's marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee.",
  },
];

const Calendars = () => {
  return (
    <Row>
      <Col xl={6} xxl={4}>
        <h3 className="mb-4">Calendars</h3>

        <Tab.Container id="email-tabs" defaultActiveKey={emailsData[0].id}>
          <Nav variant="underline" className="mb-5">
            {emailsData.map((item) => (
              <Nav.Item key={item.id}>
                <Nav.Link eventKey={item.id}>{item.email}</Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
          <Tab.Content>
            {emailsData.map((item) => (
              <Tab.Pane key={item.id} eventKey={item.id}>
                <div className="mt-4">
                  <h5>Event visibility</h5>
                  <p className="mb-0 fs-9">
                    Define what will be visible to other users in your workspace
                  </p>
                  <EventVisibilitySection />
                </div>

                <div className="mt-4">
                  <h5>Contact auto-creation</h5>
                  <p className="mb-0 fs-9">
                    Automatically create contacts for people you've participated
                    in an event with.
                  </p>
                  <div className="mt-2">
                    <ContactAutoCreationSwitch />
                  </div>
                </div>
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Tab.Container>
      </Col>
    </Row>
  );
};

export default Calendars;
